import { render, staticRenderFns } from "./shareQcode.vue?vue&type=template&id=b9d5ce9a&scoped=true"
import script from "./shareQcode.vue?vue&type=script&lang=js"
export * from "./shareQcode.vue?vue&type=script&lang=js"
import style0 from "./shareQcode.vue?vue&type=style&index=0&id=b9d5ce9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9d5ce9a",
  null
  
)

export default component.exports